import React from "react";
import EffetDef from "../components/EffetDef";
import UserRouter from "./UserRouter";


const Router = () =>{
    return (
        <>
            <UserRouter/>
            <EffetDef/>
        </>
    );
}

export default Router;